<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-toc" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">Contents</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">1. </span><a href="#/chapter001"><span class="toc-item-title-text">Ghosts, Easter, and Other Things</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">2. </span><a href="#/chapter002"><span class="toc-item-title-text">Am I Dead?</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">3. </span><span href="#/chapter003" title="Link target outside of Sample"><span class="toc-item-title-text">The Bully is Scared</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">4. </span><span href="#/chapter004" title="Link target outside of Sample"><span class="toc-item-title-text">Kyle’s Secret</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">5. </span><span href="#/chapter005" title="Link target outside of Sample"><span class="toc-item-title-text">The Inconvenience of High School</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">6. </span><span href="#/chapter006" title="Link target outside of Sample"><span class="toc-item-title-text">The Body</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">7. </span><span href="#/chapter007" title="Link target outside of Sample"><span class="toc-item-title-text">Uncle Freddie</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">8. </span><span href="#/chapter008" title="Link target outside of Sample"><span class="toc-item-title-text">Not James</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">9. </span><span href="#/chapter009" title="Link target outside of Sample"><span class="toc-item-title-text">The Demon Makes a House Call</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">10. </span><span href="#/chapter010" title="Link target outside of Sample"><span class="toc-item-title-text">To Grandma’s House We Go</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">11. </span><span href="#/chapter011" title="Link target outside of Sample"><span class="toc-item-title-text">Wilby’s in the Know</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">12. </span><span href="#/chapter012" title="Link target outside of Sample"><span class="toc-item-title-text">A Prince of a Demon</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">13. </span><span href="#/chapter013" title="Link target outside of Sample"><span class="toc-item-title-text">The Sanctity of Family</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">14. </span><span href="#/chapter014" title="Link target outside of Sample"><span class="toc-item-title-text">What’s East is West</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">15. </span><span href="#/chapter015" title="Link target outside of Sample"><span class="toc-item-title-text">A Visit from an Old Friend</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">16. </span><span href="#/chapter016" title="Link target outside of Sample"><span class="toc-item-title-text">Meet the Devil</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">17. </span><span href="#/chapter017" title="Link target outside of Sample"><span class="toc-item-title-text">The Witch’s Blood</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">18. </span><span href="#/chapter018" title="Link target outside of Sample"><span class="toc-item-title-text">After the Hurricane</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span class="toc-item-number">19. </span><span href="#/chapter019" title="Link target outside of Sample"><span class="toc-item-title-text">Prom</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="toc-item-title-text">Acknowledgments</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="toc-item-title-text">About the Author</span></span></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8d237eea